export default {
  cancellingOn: (cancelDate: string): string =>
    `Cancelled - you have access until ${cancelDate}`,
  confirmRemoveText: "REMOVE",
  removeText: "Remove",
  upgradeText: "Upgrade"
};
